import React, { useEffect, useState } from "react";
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button
} from "@mui/material";
import {
    makePUTRequestOnUserService,
} from "../../Api/api";

export const AccountType = ({
    accountTypeState,
    setAccountTypeState,
    currentUser,
    user_type,
    setValue,
    getErrorMessage,
    fetchKycDocs,        
}: any) => {
    const toastr = require("toastr");
    const [accountType, setAccountType] = useState(accountTypeState);
    const [loading, setLoading] = useState(false);

    const accountTypeSwitcher: Record<string, string> = {
        "Individual Resident": "individual_resident",
        "Individual Non-Resident": "individual_non_resident",
        "Hindu Undivided Family": "huf",
        "Sole Proprietor": "sole_proprietor",
        "Limited Liability Partnership": "llp",
        "Partnership": "partnership",
        "Trust": "trust",
        "Public Limited": "public_limited",
    };

    const accountTypeOptions = [
        "Individual Resident",
        "Individual Non-Resident",
        "Hindu Undivided Family",
        "Sole Proprietor",
        "Limited Liability Partnership",
        "Partnership",
        "Trust",
        "Public Limited",
    ];

    const reverseAccountTypeSwitcher: Record<string, string> = Object.entries(
        accountTypeSwitcher
    ).reduce((acc, [label, value]) => {
        acc[value] = label;
        return acc;
    }, {} as Record<string, string>);

    useEffect(() => {
        if (!accountTypeState) {
            setAccountType("");
            return;
        }
        const displayValue =
            reverseAccountTypeSwitcher[accountTypeState] || accountTypeState;
        setAccountType(displayValue);
    }, [accountTypeState]);

    const handleSubmit = async () => {
        if (!accountType) return;
        try {
            setLoading(true);
            const resp = await makePUTRequestOnUserService(
                "/partneruser/set_account_type/",
                {
                    userUUID: currentUser.uuid,
                    accountType,
                    user_type: user_type,
                }
            );
            if (resp.status === 200) {
                toastr.success("Updated Account Type for user");
                const rawValue = accountTypeSwitcher[accountType] || accountType;
                setAccountTypeState(rawValue);
                await fetchKycDocs();
                setValue((prev: number) => prev + 1);
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ width: 400 }}>
            <FormControl fullWidth variant="outlined">
                <InputLabel>Account Type</InputLabel>
                <Select
                    value={accountType}
                    onChange={(e) => setAccountType(e.target.value)}
                    label="Account Type"
                >
                    {accountTypeOptions.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                sx={{
                    mt: 3,
                    backgroundColor: "#262349",
                    "&:hover": { backgroundColor: "#1d1a3a" },
                    px: 4,
                }}
            >
                {loading ? "Submitting..." : "Submit"}
            </Button>
        </Box>
    );
};